var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260,
    height: 230,
    viewBox: "0 0 260 230"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__a",
    x1: -6.482,
    y1: 0.212,
    x2: -6.482,
    y2: -0.402,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__b",
    x1: -4.745,
    y1: 0.859,
    x2: -4.745,
    y2: -0.141,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__c",
    x1: -9.633,
    y1: 0.296,
    x2: -9.633,
    y2: -0.318,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__d",
    x1: -4.767,
    y1: 0.499,
    x2: -4.767,
    y2: -0.115,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__e",
    x1: -3.959,
    y1: 0.533,
    x2: -3.959,
    y2: -0.082,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__f",
    x1: -3.134,
    y1: 0.973,
    x2: -3.134,
    y2: -0.027,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__g",
    x1: -0.268,
    y1: 0.293,
    x2: -0.268,
    y2: -0.707,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__h",
    x1: -7.234,
    y1: 1.615,
    x2: -7.234,
    y2: 0.615,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__i",
    x1: -4.664,
    y1: 0.077,
    x2: -4.664,
    y2: -0.923,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__j",
    x1: 3.613,
    y1: -2.435,
    x2: 3.613,
    y2: -3.435,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__k",
    x1: -8.602,
    y1: 1.273,
    x2: -8.602,
    y2: 0.273,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__l",
    x1: -5.885,
    y1: 0.448,
    x2: -5.885,
    y2: -0.552,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__m",
    x1: -12.045,
    y1: 2.318,
    x2: -12.045,
    y2: 1.318,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__n",
    x1: 2.971,
    y1: -2.24,
    x2: 2.971,
    y2: -3.24,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__o",
    x1: -5.324,
    y1: 0.476,
    x2: -5.324,
    y2: -0.139,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__p",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__q",
    x1: 8.505,
    y1: 1,
    x2: 8.505,
    y2: 0,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__r",
    x1: 0.505,
    y1: 1.046,
    x2: 0.505,
    y2: 0,
    xlinkHref: "#info_completed_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_completed_svg__s",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#info_completed_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.011 -.055)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.176,
    cy: 13.665,
    rx: 82.176,
    ry: 13.665,
    transform: "translate(35.923 202.724)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.522 209.506s-4.846-16.451.908-28.558a25.984 25.984 0 002.1-16.3 43.7 43.7 0 00-2.308-7.651",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.805 149.505c0 2.016-3.652 7.861-3.652 7.861s-3.652-5.845-3.652-7.861a3.652 3.652 0 117.3 0zM76.835 160.657c-1.1 1.691-7.345 4.615-7.345 4.615s.114-6.893 1.208-8.584a3.652 3.652 0 016.129 3.968zM76.572 179.706c-1.8.908-8.664.278-8.664.278s3.577-5.893 5.376-6.8a3.652 3.652 0 113.288 6.521zM73.122 193.996c-1.622 1.2-8.492 1.741-8.492 1.741s2.53-6.412 4.152-7.612a3.652 3.652 0 114.34 5.87zM61.837 165.656c1.447 1.405 8.184 2.86 8.184 2.86s-1.65-6.693-3.1-8.1a3.652 3.652 0 10-5.087 5.237zM58.019 182.508c1.8.908 8.664.278 8.664.278s-3.571-5.887-5.376-6.8a3.652 3.652 0 10-3.288 6.521zM56.556 199.331c1.622 1.2 8.492 1.741 8.492 1.741s-2.53-6.412-4.152-7.612a3.652 3.652 0 10-4.34 5.871z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.805 149.505c0 2.016-3.652 7.861-3.652 7.861s-3.652-5.845-3.652-7.861a3.652 3.652 0 117.3 0zM76.835 160.657c-1.1 1.691-7.345 4.615-7.345 4.615s.114-6.893 1.208-8.584a3.652 3.652 0 016.129 3.968zM76.572 179.706c-1.8.908-8.664.278-8.664.278s3.577-5.893 5.376-6.8a3.652 3.652 0 113.288 6.521zM73.122 193.996c-1.622 1.2-8.492 1.741-8.492 1.741s2.53-6.412 4.152-7.612a3.652 3.652 0 114.34 5.87zM61.837 165.656c1.447 1.405 8.184 2.86 8.184 2.86s-1.65-6.693-3.1-8.1a3.652 3.652 0 10-5.087 5.237zM58.019 182.508c1.8.908 8.664.278 8.664.278s-3.571-5.887-5.376-6.8a3.652 3.652 0 10-3.288 6.521zM56.556 199.331c1.622 1.2 8.492 1.741 8.492 1.741s-2.53-6.412-4.152-7.612a3.652 3.652 0 10-4.34 5.871z",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.486 208.41s-4.846-16.451.908-28.558a25.985 25.985 0 002.1-16.3 43.7 43.7 0 00-2.305-7.642",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.768 148.41c0 2.016-3.652 7.862-3.652 7.862s-3.652-5.846-3.652-7.862a3.652 3.652 0 017.3 0zM172.798 159.559c-1.1 1.691-7.337 4.615-7.337 4.615s.114-6.892 1.208-8.584a3.652 3.652 0 116.129 3.968zM172.534 178.612c-1.8.908-8.664.278-8.664.278s3.577-5.893 5.376-6.8a3.652 3.652 0 113.288 6.521zM169.085 192.896c-1.622 1.2-8.492 1.741-8.492 1.741s2.53-6.412 4.152-7.612a3.652 3.652 0 014.34 5.87zM157.799 164.555c1.447 1.405 8.184 2.86 8.184 2.86s-1.65-6.693-3.1-8.1a3.652 3.652 0 00-5.087 5.237zM153.982 181.416c1.8.908 8.664.278 8.664.278s-3.577-5.89-5.376-6.8a3.652 3.652 0 10-3.288 6.521zM152.519 198.231c1.622 1.2 8.492 1.741 8.492 1.741s-2.53-6.412-4.152-7.612a3.652 3.652 0 00-4.34 5.87z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.768 148.41c0 2.016-3.652 7.862-3.652 7.862s-3.652-5.846-3.652-7.862a3.652 3.652 0 017.3 0zM172.798 159.559c-1.1 1.691-7.337 4.615-7.337 4.615s.114-6.892 1.208-8.584a3.652 3.652 0 116.129 3.968zM172.534 178.612c-1.8.908-8.664.278-8.664.278s3.577-5.893 5.376-6.8a3.652 3.652 0 113.288 6.521zM169.085 192.896c-1.622 1.2-8.492 1.741-8.492 1.741s2.53-6.412 4.152-7.612a3.652 3.652 0 014.34 5.87zM157.799 164.555c1.447 1.405 8.184 2.86 8.184 2.86s-1.65-6.693-3.1-8.1a3.652 3.652 0 00-5.087 5.237zM153.982 181.416c1.8.908 8.664.278 8.664.278s-3.577-5.89-5.376-6.8a3.652 3.652 0 10-3.288 6.521zM152.519 198.231c1.622 1.2 8.492 1.741 8.492 1.741s-2.53-6.412-4.152-7.612a3.652 3.652 0 00-4.34 5.87z",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.525 175.89s5.832 11.427 1.077 17.681.43 23.288.43 23.288",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.249 172.447a6.716 6.716 0 01-1.616 3.988 5.728 5.728 0 010-7.975 6.705 6.705 0 011.616 3.987z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.549 175.89s-5.832 11.427-1.077 17.681-.43 23.288-.43 23.288",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.819 172.447a6.716 6.716 0 001.616 3.988 5.728 5.728 0 000-7.975 6.705 6.705 0 00-1.616 3.987z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.819 172.447a6.716 6.716 0 001.616 3.988 5.728 5.728 0 000-7.975 6.705 6.705 0 00-1.616 3.987z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.915 175.89s5.832 11.427 1.077 17.681.444 23.288.444 23.288",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.639 172.447a6.716 6.716 0 01-1.616 3.988 5.728 5.728 0 010-7.975 6.705 6.705 0 011.616 3.987zM37.734 181.587a6.706 6.706 0 01-3.932 1.752 5.725 5.725 0 015.532-5.748 6.654 6.654 0 01-1.6 3.996zM37.881 189.372a6.707 6.707 0 01-3.932 1.752 5.725 5.725 0 015.532-5.748 6.7 6.7 0 01-1.6 3.996zM29.603 193.71a6.7 6.7 0 011.388 4.071 5.7 5.7 0 01-5.223-6.015 6.669 6.669 0 013.835 1.944zM30.938 176.999a6.723 6.723 0 012.433 3.552 5.73 5.73 0 01-6.651-4.407 6.717 6.717 0 014.218.855z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.938 176.999a6.723 6.723 0 012.433 3.552 5.73 5.73 0 01-6.651-4.407 6.717 6.717 0 014.218.855z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.934 175.89s-5.832 11.427-1.077 17.681-.419 23.288-.419 23.288",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.209 172.447a6.715 6.715 0 001.616 3.988 5.731 5.731 0 000-7.978 6.718 6.718 0 00-1.616 3.99z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.209 172.447a6.715 6.715 0 001.616 3.988 5.731 5.731 0 000-7.978 6.718 6.718 0 00-1.616 3.99z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.673 181.751a6.707 6.707 0 00-1.647 3.977 5.724 5.724 0 005.6-5.682 6.713 6.713 0 00-3.953 1.705z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.673 181.751a6.707 6.707 0 00-1.647 3.977 5.724 5.724 0 005.6-5.682 6.713 6.713 0 00-3.953 1.705z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.705 192.566a6.707 6.707 0 00-1.647 3.977 5.724 5.724 0 005.6-5.676 6.749 6.749 0 00-3.953 1.699z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.245 190.175s3.5-5.523 8.411-5.643M34.516 186.928s-3.5-5.523-8.423-5.643M34.06 194.724s3.5-5.523 8.423-5.643",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.911,
    cy: 0.911,
    r: 0.911,
    transform: "translate(44.598 183.672)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.911,
    cy: 0.911,
    r: 0.911,
    transform: "translate(25.268 180.419)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.637 196.543s-3.5-5.523-8.423-5.643",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.911,
    cy: 0.911,
    r: 0.911,
    transform: "translate(27.39 190.022)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.911,
    cy: 0.911,
    r: 0.911,
    transform: "translate(41.641 188.203)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.009 210.222s-8.445-1.688-10.7-3.941-12.385-6.193-13.513-3.377-15.2 12.385-5.629 14.077 22.521 2.252 25.334 1.125 4.508-7.884 4.508-7.884z",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.17 215.932c9.572 1.688 22.521 2.252 25.334 1.125 2.144-.858 3.632-4.976 4.224-6.9l.278.058s-1.686 6.759-4.5 7.895-15.765.555-25.334-1.125c-2.763-.489-3.552-1.633-3.255-3.083.242.941 1.196 1.669 3.253 2.03z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.791 189.803s2.777 3.646-1.286 9.164-7.434 10.153-6.076 13.582c0 0 6.148-10.222 11.152-10.366s1.714-6.23-3.79-12.38z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.791 189.803a4.515 4.515 0 01.569 1.144c4.882 5.737 7.484 11.091 2.777 11.224-4.371.125-9.617 7.942-10.872 9.917a4.277 4.277 0 00.15.45s6.148-10.222 11.152-10.366 1.728-6.219-3.776-12.369z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.971 194.452c0 1.283-.144 2.324-.322 2.324s-.322-1.041-.322-2.324.181-.68.358-.68.286-.603.286.68z",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.75 195.985c-1.127.614-2.108.986-2.194.833s.758-.78 1.886-1.388.683-.167.766 0 .664-.062-.458.555z",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.074 189.803s-2.777 3.646 1.286 9.164 7.434 10.153 6.076 13.582c0 0-6.148-10.222-11.152-10.366s-1.717-6.23 3.79-12.38z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.074 189.803a4.514 4.514 0 00-.569 1.144c-4.882 5.737-7.484 11.091-2.777 11.224 4.371.125 9.617 7.942 10.872 9.917a4.2 4.2 0 01-.15.45s-6.148-10.222-11.152-10.366-1.731-6.219 3.776-12.369z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.887 194.452c0 1.283.144 2.324.322 2.324s.322-1.041.322-2.324-.181-.68-.358-.68-.286-.603-.286.68z",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.119 195.985c1.127.614 2.108.986 2.194.833s-.758-.78-1.886-1.388-.683-.167-.766 0-.669-.062.458.555z",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.769 212.06s7.8-.239 10.144-1.913 11.991-3.671 12.574-.989 11.716 13.343 2.913 13.416-20.45-1.372-22.793-2.8-2.838-7.714-2.838-7.714z",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.559 221.641c-8.8.072-20.45-1.372-22.793-2.8-1.786-1.089-2.5-5-2.735-6.792h-.261s.492 6.3 2.838 7.731 13.993 2.871 22.793 2.8c2.541-.02 3.418-.925 3.368-2.263-.35.804-1.319 1.31-3.21 1.324z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-70.55 128.07 -43.188)",
    fill: "url(#info_completed_svg__a)",
    d: "M0 0h25.598v41.652H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M126.989 91.123l7.955-22.528 37.948 13.4-7.956 22.528z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M139.56 76.203l-4.83-1.705 1.262-3.572 4.83 1.705zM154.764 89.401l-18.537-6.546.408-1.157 18.538 6.546zM154.021 92.801l-13.481-4.727.27-.77 13.481 4.727z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 273.785 -377.443)",
    fill: "url(#info_completed_svg__b)",
    d: "M0 0h41.652v25.598H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.931 73.683l37.545-14.487 8.6 22.29-37.545 14.486z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M163.362 76.405l-4.778 1.844-1.364-3.535 4.778-1.843zM183.499 76.527l-18.34 7.077-.443-1.145 18.341-7.077zM184.458 79.009l-13.375 5.16-.294-.764 13.374-5.16z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-82.24 104.333 -40.628)",
    fill: "url(#info_completed_svg__c)",
    d: "M0 0h25.598v41.652H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.997 67.625l3.345-23.655 39.845 5.635-3.345 23.655z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M140.433 50.071l-5.074-.691.511-3.754 5.074.692zM158.003 59.906l-19.478-2.654.166-1.216 19.478 2.654zM157.644 62.545l-14.204-1.936.11-.811 14.205 1.936z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-82.24 95.65 17.751)",
    fill: "url(#info_completed_svg__d)",
    d: "M0 0h25.598v41.652H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.802 109.137l3.226-23.671 39.872 5.433-3.226 23.671z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M75.068 91.969l-5.074-.691.511-3.754 5.074.692zM93.273 101.352l-19.464-2.753.171-1.214 19.465 2.752zM92.276 104.443l-14.204-1.936.11-.811 14.205 1.936z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-82.24 75.88 9.109)",
    fill: "url(#info_completed_svg__e)",
    d: "M0 0h25.598v41.652H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.261 82.069l3.226-23.671 39.872 5.433-3.226 23.671z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M66.531 64.898l-5.074-.691.511-3.754 5.074.692zM84.098 74.736L64.62 72.082l.166-1.216 19.478 2.654zM83.739 77.372l-14.204-1.936.11-.811L83.85 76.56z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-16.6 311.037 -281.46)",
    fill: "url(#info_completed_svg__f)",
    d: "M0 0h41.652v25.598H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M94.046 77.593l38.564-11.496 6.825 22.894-38.564 11.496z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M102.233 80.975l-4.908 1.463-1.082-3.63 4.908-1.463zM122.298 82.686l-18.839 5.616-.35-1.176 18.838-5.616zM123.06 85.237l-13.738 4.095-.234-.785 13.738-4.095z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-16.6 307.832 -72.748)",
    fill: "url(#info_completed_svg__g)",
    d: "M0 0h41.652v25.598H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M34.282 85.375l38.564-11.496 6.825 22.894-38.564 11.496z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M42.471 88.77l-4.908 1.463-1.082-3.63 4.908-1.463zM62.536 90.477l-18.839 5.616-.35-1.176 18.838-5.616zM62.704 93.221l-13.76 4.157-.239-.787 13.761-4.157z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 138.854 -521.155)",
    fill: "url(#info_completed_svg__h)",
    d: "M0 0h41.652v25.598H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M197.627 15.48L235.172.993l8.6 22.29-37.545 14.486z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M206.041 18.211l-4.778 1.844-1.364-3.535 4.778-1.843zM226.178 18.33l-18.34 7.077-.443-1.145 18.341-7.077zM227.137 20.815l-13.375 5.16-.294-.764 13.374-5.16z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 157.328 -300.806)",
    fill: "url(#info_completed_svg__i)",
    d: "M0 0h28.986v17.814H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.324 36.765l26.127-10.081 5.985 15.512-26.127 10.081z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M125.186 38.668l-3.324 1.283-.949-2.459 3.324-1.282zM139.199 38.752l-12.763 4.924-.307-.797 12.762-4.925zM139.865 40.478l-9.307 3.591-.205-.53 9.307-3.592z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 172.427 32.121)",
    fill: "url(#info_completed_svg__j)",
    d: "M0 0h28.986v17.814H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.48 64.51l26.127-10.081 5.985 15.512L6.465 80.022z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M6.348 66.415l-3.324 1.283-.949-2.459L5.4 63.957zM20.359 66.497L7.596 71.421l-.307-.797 12.762-4.925zM21.027 68.225l-9.307 3.591-.205-.53 9.307-3.592z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 242.292 -459.332)",
    fill: "url(#info_completed_svg__k)",
    d: "M0 0h28.986v17.814H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M182.087 56.734l26.127-10.081 5.985 15.512-26.127 10.081z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M187.952 58.613l-3.324 1.283-.949-2.459 3.324-1.282zM201.963 58.698L189.2 63.622l-.307-.797 12.762-4.925zM202.631 60.426l-9.307 3.591-.205-.53 9.307-3.592z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 109.688 -349.905)",
    fill: "url(#info_completed_svg__l)",
    d: "M0 0h28.986v17.814H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M133.807 16.326l26.127-10.081 5.985 15.512-26.127 10.081z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M139.668 18.226l-3.324 1.283-.949-2.459 3.324-1.282zM153.681 18.31l-12.763 4.924-.307-.797 12.762-4.925zM154.35 20.038l-9.307 3.591-.205-.53 9.307-3.592z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 169.245 -597.752)",
    fill: "url(#info_completed_svg__m)",
    d: "M0 0h28.986v17.814H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M227.023 21.163l26.127-10.081 5.985 15.512-26.127 10.081z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M232.878 23.051l-3.324 1.283-.949-2.459 3.324-1.282zM246.889 23.136l-12.763 4.924-.307-.797 12.762-4.925zM247.558 24.867l-9.307 3.591-.205-.53 9.307-3.592z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-21.1 78.46 6.369)",
    fill: "url(#info_completed_svg__n)",
    d: "M0 0h28.986v17.814H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f6f7",
    d: "M3.458 28.956l26.127-10.081 5.985 15.512L9.443 44.468z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M9.318 30.87l-3.324 1.283-.949-2.459 3.324-1.282zM23.331 30.954l-12.763 4.924-.307-.797 12.762-4.925zM23.997 32.683l-9.307 3.591-.205-.53 9.307-3.592z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-82.24 76.455 -9.126)",
    fill: "url(#info_completed_svg__o)",
    d: "M0 0h25.598v41.652H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.826 66.871L79.052 43.2l39.872 5.433-3.226 23.671z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M85.099 49.695l-5.074-.691.511-3.754 5.074.692zM102.669 59.533l-19.478-2.654.166-1.216 19.478 2.654zM102.31 62.172l-14.204-1.936.11-.811 14.205 1.936z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.037 245.33a17.87 17.87 0 00-5.362-11.075c-3.649-3.541-10.1-8.236-20.827-11.716-19.591-6.362-26.97-11.958-35.62-27.214l-7.635-18.825v8.65l-4.835-18.328s-2.163 19.464 4.443 34.99c0 0-3.307 2.8 0 7.634 0 0-7.887-1.272-1.272 11.7l5.6 8.142s-5.6 2.544 2.291 11.449l4.59 4.318s-10.941 3.563 3.563 16.284c0 0 18.572 15.012 33.585 10.686 13.148-3.796 22.779-13.237 21.479-26.695z",
    transform: "translate(-240.574 -130.313)",
    fill: "url(#info_completed_svg__p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.555 114.395a17.436 17.436 0 00-5.237-10.805c-3.56-3.455-9.855-8.037-20.308-11.433-19.117-6.207-26.315-11.663-34.757-26.564l-7.448-18.37v8.442L43.084 37.79s-2.11 18.992 4.343 34.134c0 0-3.227 2.73 0 7.448 0 0-7.695-1.241-1.241 11.419l5.469 7.949s-5.462 2.483 2.222 11.172l4.468 4.221s-10.675 3.477 3.477 15.887c0 0 18.122 14.646 32.768 10.428 12.839-3.698 22.236-12.908 20.965-26.053z",
    fill: "#dfe5ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.362 85.556l-14.4-35.5s1.488 16.881 5.212 24.082c0 0-4.721-3.227 1.986 10.427 0 0-14.4-10.922 0 11.172l5.709 5.462s-10.144-4.346-4.9 4.443a24.84 24.84 0 008.025 8.2l4.324 2.752s-14.4-4.468-4.965 8.689c0 0 10.178 9.683 16.634 10.427 0 0-16.634-10.675-12.66-14.646s14.9 2.971 14.9 2.971-19.364-13.4-18.37-16.881 10.427 4.468 10.427 4.468-19.861-19.117-18.867-22.094 1.488-3.227 7.945 3.227c0 0-8.442-11.916-7.2-13.654s6.2 6.455 6.2 6.455z",
    fill: "#ebf1f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.507 128.736s13.885-16.384-13.157-25.826a136.9 136.9 0 01-19.93-8.67 48.975 48.975 0 01-23.932-29.673c-.669-2.358-.978-4.135-.58-4.6 0 0 8.192 21.846 25.323 29.541l22.591 8.442s25.822 9.686 9.685 30.786z",
    fill: "#ebf1f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.693 245.3a17.87 17.87 0 015.362-11.075c3.649-3.541 10.1-8.236 20.827-11.716 19.591-6.362 26.97-11.958 35.62-27.214l7.614-18.839v8.65l4.835-18.328s2.163 19.464-4.443 34.99c0 0 3.307 2.8 0 7.634 0 0 7.887-1.272 1.272 11.7l-5.6 8.142s5.6 2.546-2.294 11.458l-4.579 4.327s10.941 3.563-3.563 16.284c0 0-18.572 15.012-33.585 10.686-13.135-3.799-22.768-13.24-21.466-26.699z",
    transform: "translate(-453.121 -130.284)",
    fill: "url(#info_completed_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.474 114.395a17.436 17.436 0 015.232-10.805c3.56-3.455 9.855-8.037 20.308-11.433 19.117-6.207 26.315-11.663 34.757-26.564l7.448-18.37v8.442l4.721-17.875s2.11 18.992-4.343 34.134c0 0 3.227 2.73 0 7.448 0 0 7.7-1.241 1.241 11.419l-5.462 7.945s5.462 2.483-2.222 11.172l-4.468 4.221s10.675 3.477-3.477 15.887c0 0-18.122 14.646-32.768 10.428-12.838-3.694-22.236-12.904-20.967-26.049z",
    fill: "#dfe5ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67 85.556l14.4-35.5s-1.489 16.881-5.213 24.082c0 0 4.721-3.227-1.985 10.427 0 0 14.4-10.922 0 11.172l-5.712 5.46s10.144-4.346 4.9 4.443a24.84 24.84 0 01-8.025 8.2l-4.324 2.752s14.39-4.471 4.965 8.686c0 0-10.178 9.683-16.634 10.428 0 0 16.634-10.675 12.66-14.646s-14.9 2.98-14.9 2.98 19.364-13.4 18.37-16.881-10.427 4.468-10.427 4.468 19.861-19.117 18.867-22.094-1.489-3.227-7.945 3.227c0 0 8.442-11.916 7.2-13.654s-6.197 6.45-6.197 6.45z",
    fill: "#ebf1f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.527 128.736s-13.885-16.384 13.157-25.826a136.9 136.9 0 0019.93-8.67 48.974 48.974 0 0023.926-29.677c.669-2.358.978-4.135.58-4.6 0 0-8.192 21.846-25.323 29.541l-22.591 8.442s-25.816 9.69-9.679 30.79z",
    fill: "#ebf1f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.78 551.26a.256.256 0 00.3.039 1.031 1.031 0 01-.3-.039z",
    transform: "translate(-426.503 -408.151)",
    fill: "url(#info_completed_svg__r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.994 309.35c-.6-.175-1.452-.458-2.48-.814a13.015 13.015 0 002.3-4.632l-.089.033c.031-.1.061-.205.089-.308-1.972.8-4.165-.555-5.554-2.3s-2.333-3.9-3.854-5.509a17.633 17.633 0 00-2.044-1.758 2.728 2.728 0 00-1.48-.725c-.889-.025-1.583.833-2.441 1.111a3.333 3.333 0 01-1.7-.064c-2.2-.505-4.335-1.441-6.576-1.686a7.708 7.708 0 00-3.568.4c-1.13.43-1.647 1.283-2.563 1.969-.986.736-2.949.719-4.11.85a29.428 29.428 0 01-4.246.175 9.937 9.937 0 00-2.444.092c-1.686.369-3.055 1.711-4.307 3a2.221 2.221 0 00-.711 1.111 1.407 1.407 0 000 .369 2.4 2.4 0 00.169.98 12.957 12.957 0 001.636 3.252 9.6 9.6 0 011.411 2.31 4.479 4.479 0 01.217 1.33 9.678 9.678 0 01-.15 1.43 17.978 17.978 0 01-1.094 3.807 6.637 6.637 0 00-.639 2.011 3.185 3.185 0 000 .425c-.083 2.2 2.133 3.777 2.56 5.959a3.566 3.566 0 01.061.555 3.733 3.733 0 01-1.966 3.219c.1.039.2.072.305.108a2.775 2.775 0 01-.305.167c.208.081.422.147.639.208a14.837 14.837 0 00-3.238 3.968c-3.827 7.153-29.88 21.188-29.88 21.188s.147.081.386.219l-.314.2c-2.255 1.5-7.551 5.876-2.777 11.408 0 0 3.738-5.9 6.354-8.409.117-.111.231-.217.344-.314a.763.763 0 01.1.605l17.139-9.631s6.09-4.265 7.789-5.229a14.36 14.36 0 013.863-1.666l-.2.083a7.824 7.824 0 011.966-.278c3.035.047 6.32 2.269 7.4 11.069 1.452 11.785.778 13.91.314 14.2a.856.856 0 01-.158-.017.275.275 0 00.044.033.892.892 0 01-.186-.033.278.278 0 00.253.061.236.236 0 00.192-.022 1.968 1.968 0 00.228 0 2.548 2.548 0 01-.022.331c-.022 0-.136.061-.014.069a22.196 22.196 0 000 2.144c-1.508.083-3.013.172-4.332.253l.117-.622.053-.278c1.158-.092 2.255-.433 2.385-1.372.278-2.063-2.549-3.163-4.957-3.3s-16.856.833-16.856.833-2.166 2.8 4.7 3.674q.306.158.636.347a76.171 76.171 0 018.092 5.751l.244.194-.786.625c4.249.964 8.356 17.2 10.625 24.626s7.22 7.154 11.333 6.054c3.849-1.033 4.34-12.219 4.388-13.607v-.144l6.845 8.439.519.642q.3.155.591.294c5.185 2.466 10.911-2.263 9.281-7.642-1.647-5.435-4.2-13.465-5.907-16.865-1.427-2.844-3.271-7.567-4.39-10.527a3.554 3.554 0 00.422-.2l-.069-.375.069-.039a104.905 104.905 0 01-1.738-14.637v-.517a29.977 29.977 0 012.022-.392l.022-.278-.144.03.689-7.884s2.527-5.379.591-7.62a4.7 4.7 0 01-1.136-2.327c-.322-2.06 0-5.5 4.51-8.35 6.942-4.4 9.633-7.978 9.633-7.978s.148-2.624-4.101-3.862zm-13.782 5.468v-3.643c1.289-.064 2.6.086 3.888 0a9.859 9.859 0 001.88-.314l.311.217a34.258 34.258 0 01-6.079 3.74zm-19.68 57.1c.511.353 1.022.719 1.525 1.086.311 1.8.589 3.055.608 3.155a24.9 24.9 0 00-2.134-4.239z",
    transform: "translate(-304.8 -221.339)",
    fill: "url(#info_completed_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.722 147.557l-.3 1.627-.228 1.244-.419 2.277-4.066 2.846s-.367-.311-.972-.808a70.841 70.841 0 00-7.739-5.665 8.672 8.672 0 00-2.127-.98z",
    fill: "#ffbdc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.722 147.566l-.3 1.627a12.624 12.624 0 01-2.683-.136l-9.486.136c-.45-.028-.869-.061-1.261-.1a8.668 8.668 0 00-2.127-.98z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.736 148.788s4.743.814 5.013-1.219-2.438-3.116-4.743-3.252-16.126.814-16.126.814-2.438 3.252 6.368 3.793z",
    fill: "#7679b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.722 147.557l-.3 1.627-.228 1.244-.419 2.277-4.066 2.846s-.367-.311-.972-.808a70.841 70.841 0 00-7.739-5.665 8.672 8.672 0 00-2.127-.98z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.722 147.566l-.3 1.627a12.624 12.624 0 01-2.683-.136l-9.486.136c-.45-.028-.869-.061-1.261-.1a8.668 8.668 0 00-2.127-.98z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.736 148.788s4.743.814 5.013-1.219-2.438-3.116-4.743-3.252-16.126.814-16.126.814-2.438 3.252 6.368 3.793z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a66477",
    d: "M107.305 82.095h24.798V111.5h-24.798z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.305 82.095h24.798V111.5h-24.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27 132.344a3.969 3.969 0 00-1.511 1.069c-2.5 2.474-6.079 8.281-6.079 8.281-4.576-5.451.475-9.755 2.646-11.238.525-.358.878-.555.878-.555zM124.441 91.369s1.219 8.536 5.421 10.569-5.421 5.832-5.421 5.832l-13.143-4.879s7.453-2.438 5.962-9.622zM110.364 142.622l-.3 1.627-.228 1.244-.419 2.277-4.065 2.846s-.367-.311-.972-.808a70.852 70.852 0 00-7.739-5.665 8.664 8.664 0 00-2.127-.98z",
    fill: "#ffbdc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.363 142.631l-.3 1.627a12.627 12.627 0 01-2.682-.136l-9.486.136c-.45-.028-.869-.061-1.261-.1a8.659 8.659 0 00-2.127-.98z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.385 143.852s4.743.814 5.013-1.219-2.438-3.116-4.743-3.252-16.126.814-16.126.814-2.438 3.252 6.368 3.793z",
    fill: "#7679b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.833 145.495l-.419 2.277-4.065 2.846s-.367-.311-.972-.808l5.376-4.41z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.657 176.471q-.278-.136-.555-.278l-.5-.63-6.557-8.325v.142c-.044 1.388-.514 12.391-4.2 13.407-3.929 1.083-8.672 1.355-10.83-5.962s-6.109-23.307-10.164-24.254l6.029-4.946a36.2 36.2 0 015.623 9.142c-.061-.278-2.819-13.166-.542-15.443h19.772s3.055 8.7 5.148 13.007c1.63 3.346 4.077 11.258 5.651 16.612a6.365 6.365 0 01-8.875 7.528z",
    fill: "#7679b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.101 141.835c-3.055 1.808-16.465 1.072-20.827.778l-1.186-.086c-.128 0 .019-.072.019-.072l.122-1.23 3.252-8.267 17.413-10.095a15.147 15.147 0 00-.444 4.554 103.8 103.8 0 001.651 14.418z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.101 141.431c-3.055 1.808-16.465 1.072-20.827.778l-1.186-.086-.2-.014.217-.056 1.069-.278 2.3-9.214 17.412-10.094a15.146 15.146 0 00-.444 4.554 103.777 103.777 0 001.659 14.41z",
    fill: "#f2f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.436 127.016c-3.541.816-11.333 3.213-14.326 9-2 3.854-3.677 5.507-4.849 6.2l-1.186-.086.019-.072 1.069-.278 2.3-9.214 17.412-10.094a14.8 14.8 0 00-.439 4.544zM74.209 129.917l4.065 2.438a3.97 3.97 0 00-1.511 1.069c-.339-.989-2.469-2.369-3.432-2.955.519-.358.878-.552.878-.552zM113.352 142.267a.242.242 0 01-.278-.039.977.977 0 00.278.039z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.559 101.372a8.059 8.059 0 01-6.234-2.3s-10.83 3.116-14.5 10.164-28.6 20.869-28.6 20.869 4.335 2.438 3.929 3.657l16.384-9.486s5.832-4.2 7.453-5.149 10.569-6.776 12.466 9.078 0 13.957 0 13.957 2.71.95 6.64-6.64 16.146-9.357 16.146-9.357l.678-7.995s2.419-5.3.555-7.5a4.691 4.691 0 01-1.086-2.294c-.308-2.03 0-5.412 4.313-8.223 6.64-4.335 9.214-7.859 9.214-7.859s.136-2.574-3.929-3.793-20.6-7.859-20.6-7.859l-.555 2.3 13.01 9.223s-6.5 5.276-11.663 5.148c.039-.006.986 3.923-3.621 4.059z",
    fill: "#565388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.057 95.096a26.63 26.63 0 01-.75-3.31l-7.181 1.9a7.918 7.918 0 01-.164 4.143 7.723 7.723 0 008.095-2.733z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.723,
    cy: 7.723,
    r: 7.723,
    transform: "translate(111.371 82.243)",
    fill: "#ffbdc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.198 72.411c2.144.242 4.182 1.164 6.29 1.666a3.107 3.107 0 001.627.061c.833-.253 1.486-1.111 2.335-1.086a2.58 2.58 0 011.416.714 17.015 17.015 0 011.944 1.733c1.455 1.58 2.358 3.707 3.688 5.426s3.421 3.055 5.307 2.266c-1.283 5-5.484 8.806-10.03 9.117-1.813.125-3.671-.255-5.426.278a4.753 4.753 0 01-1.369.333c-1.011 0-1.824-.928-2.455-1.83-1.477-2.122-2.646-4.529-4.31-6.465a3.553 3.553 0 00-1.974-1.364 3.653 3.653 0 00-2.183.611 10.212 10.212 0 00-3.194 2.222 4.439 4.439 0 00-1.077 3.888 9.086 9.086 0 01.655 2.177c.014 1.23-1.072 2.133-1.289 3.332a12.842 12.842 0 00-.053 1.516 6.2 6.2 0 01-2.291 4.024 2.907 2.907 0 00-1.047 1.452c-.086.425 0 .872-.055 1.3a2.363 2.363 0 01-2.169 1.747 6.288 6.288 0 01-3.255-.386 3.761 3.761 0 001.822-3.982c-.419-2.2-2.63-3.777-2.444-6.018a6.961 6.961 0 01.611-1.98 18.119 18.119 0 001.047-3.752 6.4 6.4 0 00-.064-2.991 9.3 9.3 0 00-1.35-2.274 12.915 12.915 0 01-1.555-3.2 2.244 2.244 0 01-.15-1.061 2.194 2.194 0 01.68-1.1c1.211-1.269 2.5-2.591 4.118-2.952a9.237 9.237 0 012.338-.089 27.361 27.361 0 004.063-.172c1.111-.131 2.988-.111 3.932-.833.878-.675 1.369-1.516 2.452-1.944a7.176 7.176 0 013.415-.384zM127.49 152.016s4.471 8.809 3.116 11.519M135.593 175.54l-6.551-8.311v.142s-.378-2.688.869-1.786c2.732 1.977 7.1 5.218 7.2 5.776s-.888 2.802-1.518 4.179z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.355 97.309a3.313 3.313 0 01-1.236 3.432 3.051 3.051 0 002.777-3.541 8.681 8.681 0 01-1.541.109zM74.864 129.556s24.932-13.821 28.6-20.869c2.624-5.057 8.95-8.089 12.313-9.4-2.452.833-10.7 3.971-13.8 9.942-3.657 7.045-28.6 20.869-28.6 20.869zM131.201 96.23a29.344 29.344 0 008.3-4.615l-13.007-9.214.3-1.264-1.247-.5-.555 2.3 13.007 9.214a31.379 31.379 0 01-6.798 4.079zM131.284 127.457a32.229 32.229 0 015.112-1.291l.022-.261a34.53 34.53 0 00-5.134 1.552zM115.517 141.653h-.119a.244.244 0 01-.278-.039 1.012 1.012 0 00.278.039c.444-.258 1.111-2.283-.278-14-1.5-12.5-7.373-11.522-10.589-10.083 3.288-.905 7.812-.122 9.1 10.625 1.388 11.713.733 13.735.278 14a3 3 0 001.608-.542zM113.903 142.197a1.008 1.008 0 01-.278-.039.244.244 0 00.278.039z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.198 72.14c2.144.242 4.182 1.164 6.29 1.666a3.107 3.107 0 001.627.061c.833-.253 1.486-1.111 2.335-1.086a2.581 2.581 0 011.416.714 17.013 17.013 0 011.944 1.733c1.455 1.58 2.358 3.707 3.688 5.426s3.421 3.055 5.307 2.266c-1.283 5-5.484 8.806-10.03 9.117-1.813.125-3.671-.255-5.426.278a4.751 4.751 0 01-1.369.333c-1.011 0-1.824-.928-2.455-1.83-1.477-2.122-2.646-4.529-4.31-6.465a3.553 3.553 0 00-1.974-1.364 3.653 3.653 0 00-2.183.611 10.212 10.212 0 00-3.194 2.222 4.439 4.439 0 00-1.077 3.888 9.086 9.086 0 01.655 2.177c.014 1.23-1.072 2.133-1.289 3.332a12.844 12.844 0 00-.053 1.516 6.2 6.2 0 01-2.291 4.024 2.907 2.907 0 00-1.047 1.452c-.086.425 0 .872-.055 1.3a2.363 2.363 0 01-2.169 1.747 6.287 6.287 0 01-3.255-.386 3.761 3.761 0 001.822-3.982c-.419-2.2-2.63-3.777-2.444-6.018a6.961 6.961 0 01.611-1.98 18.118 18.118 0 001.047-3.752 6.4 6.4 0 00-.064-2.991 9.3 9.3 0 00-1.35-2.274 12.918 12.918 0 01-1.555-3.2 2.244 2.244 0 01-.15-1.061 2.194 2.194 0 01.68-1.1c1.211-1.269 2.5-2.591 4.118-2.952a9.234 9.234 0 012.338-.089 27.37 27.37 0 004.063-.172c1.111-.131 2.988-.111 3.932-.833.878-.675 1.369-1.516 2.452-1.944a7.175 7.175 0 013.415-.384z",
    fill: "#a66477"
  }))));
}

export default SvgInfoCompleted;